module.exports = __webpack_public_path__ + "9c13ce571d89d427d9a56ba75aac859b.svg";